/**
 * Order for a dragged item that has just been dropped onto `targetIndex`.
 * Mid-list drops sit halfway between neighbours; end drops use +100 / -50.
 * Callers persist `Math.floor` of this value — matching the existing
 * list, filter, and task reorder writes.
 */
export function interpolatedOrderPosition(
  items: { order_position: number }[],
  draggedIndex: number,
  targetIndex: number,
): number {
  const target = items[targetIndex];
  if (draggedIndex < targetIndex) {
    const next = items[targetIndex + 1];
    return next
      ? (target.order_position + next.order_position) / 2
      : target.order_position + 100;
  }
  const prev = items[targetIndex - 1];
  return prev
    ? (prev.order_position + target.order_position) / 2
    : target.order_position - 50;
}
